import React from 'react';
import {
  Container,
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link as StyledLink,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { ConfigContext } from '../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    margin: theme.spacing(0),
  },
  paper: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Contact({ match }) {
  const classes = useStyles();
  const config = React.useContext(ConfigContext);

  const { action } = match.params;

  function form() {
    if (action === 'confirm') {
      return <div>Thanks</div>;
    }
    if (action === 'add') {
      return <div>Add event</div>;
    }
    if (action === 'form') {
      return (
        <form className={classes.form} method="post">
          <input type="hidden" name="form-name" value="contact" />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                multiline
                variant="outlined"
                required
                fullWidth
                name="message"
                label="Message"
                type="message"
                id="message"
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Send
          </Button>
          <div data-netlify-recaptcha="true"></div>
        </form>
      );
    }
    return null;
  }

  return (
    <Container maxWidth="lg" className="root">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact | electronic music calendar</title>
        <link rel="canonical" href={`${config.siteUrl}/contact`} />
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Typography variant="h5">
              <StyledLink component={Link} to="/">
                Home
              </StyledLink>{' '}
              &gt; Contact
            </Typography>
          </Paper>

          <Paper className={classes.paper}>{form()}</Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

Contact.propTypes = {
  match: PropTypes.object,
};
